import React__default from 'react';
import { Icon } from '../components/internal/Icon.mjs';

function ResolveIcon(props) {
  return /* @__PURE__ */ React__default.createElement(Icon, {
    ...props
  }, /* @__PURE__ */ React__default.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 7
  }), /* @__PURE__ */ React__default.createElement("path", {
    d: "m13 8-4 4-2-2"
  }));
}

export { ResolveIcon };
//# sourceMappingURL=Resolve.mjs.map
